// services/home.service.ts

import { NextBestWorkout } from "../models/next-best-workout";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

interface NextBestWorkoutResponse {
  data?: NextBestWorkout;
  error?: { message: string };
}

/**
 * Fetch the structured next-best-workout recommendation (v2 engine) for the
 * Home "Recommended next" card.
 */
export async function getNextBestWorkout(
  accessToken: string,
  timezone: string
): Promise<NextBestWorkoutResponse> {
  try {
    const res = await fetch(
      `${apiServerUrl}/api/next-best-workout?timezone=${encodeURIComponent(timezone)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.ok) {
      const errBody = await res.json().catch(() => ({ message: res.statusText }));
      return { error: { message: errBody.message || "Request failed" } };
    }

    const data: NextBestWorkout = await res.json();
    return { data };
  } catch (e: any) {
    return { error: { message: e.message } };
  }
}
